import { useTranslation } from 'react-i18next';

export const keyPrefix = 'create_user';
export const useCreateUserTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    add_button: 'Добавить',
    confirmation_error: 'Не удалось создать пользователя',
    confirmation_success: 'Пользователь успешно создан',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    add_button: 'Add',
    confirmation_error: 'Failed to create user',
    confirmation_success: 'User was successfully created',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    add_button: 'Crear',
    confirmation_error: 'No se pudo crear el usuario',
    confirmation_success: 'Usuario creado correctamente',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    add_button: 'Adicionar',
    confirmation_error: 'Falha ao criar usuário',
    confirmation_success: 'Usuário criado com sucesso',
  },
}) as Record<string, unknown>;
